"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var configuration_exports = {};
__export(configuration_exports, {
  RecognizedDataType: () => RecognizedDataType,
  scannerConfiguration: () => scannerConfiguration
});
module.exports = __toCommonJS(configuration_exports);
function scannerConfiguration(options) {
  var _options_qualityLevel, _options_recognizesMultipleItems, _options_isHighFrameRateTrackingEnabled, _options_isPinchToZoomEnabled, _options_isGuidanceEnabled, _options_isHighlightingEnabled;
  return {
    recognizedDataTypes: options.recognizedDataTypes.map(function(value) {
      var _value_languages, _value_symbologies;
      return {
        ...value,
        languages: (_value_languages = value.languages) === null || _value_languages === void 0 ? void 0 : _value_languages.slice(),
        symbologies: (_value_symbologies = value.symbologies) === null || _value_symbologies === void 0 ? void 0 : _value_symbologies.slice()
      };
    }),
    qualityLevel: (_options_qualityLevel = options.qualityLevel) !== null && _options_qualityLevel !== void 0 ? _options_qualityLevel : "balanced",
    recognizesMultipleItems: (_options_recognizesMultipleItems = options.recognizesMultipleItems) !== null && _options_recognizesMultipleItems !== void 0 ? _options_recognizesMultipleItems : false,
    isHighFrameRateTrackingEnabled: (_options_isHighFrameRateTrackingEnabled = options.isHighFrameRateTrackingEnabled) !== null && _options_isHighFrameRateTrackingEnabled !== void 0 ? _options_isHighFrameRateTrackingEnabled : true,
    isPinchToZoomEnabled: (_options_isPinchToZoomEnabled = options.isPinchToZoomEnabled) !== null && _options_isPinchToZoomEnabled !== void 0 ? _options_isPinchToZoomEnabled : true,
    isGuidanceEnabled: (_options_isGuidanceEnabled = options.isGuidanceEnabled) !== null && _options_isGuidanceEnabled !== void 0 ? _options_isGuidanceEnabled : true,
    isHighlightingEnabled: (_options_isHighlightingEnabled = options.isHighlightingEnabled) !== null && _options_isHighlightingEnabled !== void 0 ? _options_isHighlightingEnabled : false
  };
}
var RecognizedDataType = {
  text() {
    var languages = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], textContentType = arguments.length > 1 ? arguments[1] : void 0;
    return {
      type: "text",
      languages,
      textContentType
    };
  },
  barcode() {
    var symbologies = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return {
      type: "barcode",
      symbologies
    };
  }
};
//# sourceMappingURL=configuration.js.map
